import { render } from "./InstructionModal.vue?vue&type=template&id=51ef1640&scoped=true"
import script from "./InstructionModal.vue?vue&type=script&lang=js"
export * from "./InstructionModal.vue?vue&type=script&lang=js"

import "./InstructionModal.vue?vue&type=style&index=0&id=51ef1640&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ef1640"]])

export default __exports__